import { useEffect, useState } from "react";
import { fetchMasterCategories } from "../../../../node_modules/shops-query/src/modules/masterCategories";
import { fetchSecondaryCategories } from "../../../../node_modules/shops-query/src/modules/SecondaryCategories";
import { imagePrefix, shopid } from "../../../utils/url";
import { useNavigate } from "react-router-dom";

const ShopByCategory = () => {
  const [secondaryCategories, setSecondaryCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMenSecondaryCategories = async () => {
      try {
        const masterCategories = await fetchMasterCategories(shopid);
        const menCategory = masterCategories.find(
          (cat) => cat.category && cat.category.toLowerCase() === "men"
        );
        if (menCategory) {
          const secCats = await fetchSecondaryCategories(shopid, menCategory.id);
          setSecondaryCategories(secCats);
        } else {
          setSecondaryCategories([]);
        }
      } catch (error) {
        console.log("Error while fetching secondary categories for Men", error);
        setSecondaryCategories([]);
      } finally {
        setLoading(false);
      }
    };
    fetchMenSecondaryCategories();
  }, []);

  return (
    <div className="w-full flex flex-col items-center mt-10 px-4 md:px-0">
    {loading ? (
      <div>Loading...</div>
    ) : secondaryCategories.length === 0 ? (
      <div>No categories found for Men.</div>
    ) : (
      <div className="w-full">
        <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center items-center sm:items-stretch">
          {secondaryCategories.map((category) => (
            <div
              key={category.id}
              className="
                relative
                flex-shrink-0
                w-full
                max-w-[355px]
                sm:max-w-[calc(50%-8px)]
                lg:max-w-[calc(33.333%-11px)]
                aspect-square
                overflow-hidden
                cursor-pointer"
                onClick={() =>
                  navigate(`/all-products?mainCategory=Men&category=${encodeURIComponent(category.category)}`)
                }
            >
              <img
                src={imagePrefix + category.image}
                alt={category.category}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 bg-neutral-black bg-opacity-70 px-4 py-2 mb-[24px] border border-white">
                <p className="text-white text-base font-semibold text-center whitespace-nowrap uppercase text-[18px]">
                  {category.category}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      )}
    </div>
  );
};

export default ShopByCategory;